import { render, staticRenderFns } from "./LocationIndex.vue?vue&type=template&id=52714cd2"
import script from "./LocationIndex.vue?vue&type=script&lang=js"
export * from "./LocationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports